import { is, last } from "ramda";
import { Maybe } from "../types";

export default function unwrap(text: Maybe<string>): string | undefined {
	if (is(String, text)) {
		if (text[0] == '"' && last(text) == '"')
			return JSON.parse(text);
		return text
	}
}